import { CheckboxGroup, Id, SubmitButton } from "@dgs/core";
import { Form, Formik } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { BasePreference, Preference } from "../../shared/types/preference";
import { CategoryOrPreferences } from "./MyPreferencesComponents";

const Wrapper = styled.div<{ $rows: number }>`
	align-items: start;
	display: grid;
	gap: ${({ theme }) => theme.spacing(10)};
	padding: ${({ theme }) => theme.spacing(5)} 0;
	grid-auto-flow: row;
	grid-auto-rows: max-content;
	grid-template-columns: 1fr;

	${({ $rows }) => css`
		grid-template-rows: repeat(${$rows}, max-content);
	`};
`;

interface Props {
	preferences: Preference[];
	myPreferences: BasePreference[];
	onSubmit: (values: { preferenceIds: Id[] }) => void;
}

export const MyPreferencesForm: FC<Props> = ({ preferences, myPreferences, onSubmit }) => {
	const { t } = useTranslation();

	return (
		<Formik initialValues={{ preferenceIds: myPreferences.map((preference) => preference.id) }} onSubmit={onSubmit}>
			<Form>
				<Wrapper $rows={preferences.length}>
					<CheckboxGroup name="preferenceIds">
						{preferences.map((preference) => (
							<CategoryOrPreferences key={preference.id} index={3} preference={preference} />
						))}
					</CheckboxGroup>
				</Wrapper>
				<SubmitButton>{t("Save your preferences")}</SubmitButton>
			</Form>
		</Formik>
	);
};
